import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class KindIcon extends Field {
  static subqueriesForModel() {
    return { workflowKind: ['iconName'] };
  }

  get title() {
    return 'Type icon';
  }

  exampleContents(): FieldContentsData {
    return { icon: { name: 'fa-solid fa-bug' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.workflowKind) {
      return { icon: { name: `fa-solid ${record.workflowKind.iconName}` } };
    }

    return {};
  }
}
